import { forwardRef, useState, useImperativeHandle, useEffect, useMemo } from 'react';
import styles from './index.module.scss'
import PSAIModal from '@PSAIComponents/PSAIModal';
import Utils from '@utils/utils';
import Iconfont from '@utils/Iconfont';
import { Row, Col, Select, Button } from 'antd';
import API from "@api/api";

const CategoryList = [
    { value: '13109', title: '女装-上装' },
    { value: '13119', title: '女装-下装' },
    { value: '13196', title: '男装-上装' },
    { value: '13213', title: '男装-下装' },
    { value: '13458', title: '童装-上装' },
    { value: '13447', title: '童装-下装' },
    { value: '13519', title: '女鞋' },
    { value: '13729', title: '男鞋' },
    { value: '15424', title: '箱包' },
    { value: '13539', title: '配饰' },
    { value: '14067', title: '童鞋' }
]


const ColorList = [
    { title: '乳白色', value: '乳白色' },
    { title: '白色', value: '白色' },
    { title: '米白色', value: '米白色' },
    { title: '浅灰色', value: '浅灰色' },
    { title: '深灰色', value: '深灰色' },
    { title: '灰色', value: '灰色' },
    { title: '银色', value: '银色' },
    { title: '黑色', value: '黑色' },
    { title: '桔红色', value: '桔红色' },
    { title: '玫红色', value: '玫红色' },
    { title: '粉红色', value: '粉红色' },
    { title: '红色', value: '红色' },
    { title: '藕色', value: '藕色' },
    { title: '西瓜红', value: '西瓜红' },
    { title: '酒红色', value: '酒红色' },
    { title: '卡其色', value: '卡其色' },
    { title: '姜黄色', value: '姜黄色' },
    { title: '明黄色', value: '明黄色' },
    { title: '杏色', value: '杏色' },
    { title: '柠檬黄', value: '柠檬黄' },
    { title: '桔色', value: '桔色' },
    { title: '浅黄色', value: '浅黄色' },
    { title: '荧光黄', value: '荧光黄' },
    { title: '金色', value: '金色' },
    { title: '香槟色', value: '香槟色' },
    { title: '黄色', value: '黄色' },
    { title: '军绿色', value: '军绿色' },
    { title: '墨绿色', value: '墨绿色' },
    { title: '浅绿色', value: '浅绿色' },
    { title: '绿色', value: '绿色' },
    { title: '翠绿色', value: '翠绿色' },
    { title: '荧光绿', value: '荧光绿' },
    { title: '青色', value: '青色' },
    { title: '天蓝色', value: '天蓝色' },
    { title: '孔雀蓝', value: '孔雀蓝' },
    { title: '宝蓝色', value: '宝蓝色' },
    { title: '浅蓝色', value: '浅蓝色' },
    { title: '深蓝色', value: '深蓝色' },
    { title: '湖蓝色', value: '湖蓝色' },
    { title: '蓝色', value: '蓝色' },
    { title: '藏青色', value: '藏青色' },
    { title: '浅紫色', value: '浅紫色' },
    { title: '深紫色', value: '深紫色' },
    { title: '紫红色', value: '紫红色' },
    { title: '紫罗兰', value: '紫罗兰' },
    { title: '紫色', value: '紫色' },
    { title: '咖啡色', value: '咖啡色' },
    { title: '巧克力色', value: '巧克力色' },
    { title: '栗色', value: '栗色' },
    { title: '浅棕色', value: '浅棕色' },
    { title: '深卡其布色', value: '深卡其布色' },
    { title: '深棕色', value: '深棕色' },
    { title: '褐色', value: '褐色' },
    { title: '驼色', value: '驼色' },
    { title: '花色', value: '花色' },
    { title: '透明', value: '透明' },
    { title: '咖色', value: '咖色' },
    { title: '米色', value: '米色' },
    { title: '裸色', value: '裸色' },
    { title: '粉色', value: '粉色' },
    { title: '橙色', value: '橙色' },
    { title: '彩色', value: '彩色' },
    { title: '肤色', value: '肤色' }
]


const SmartDetailPageCom = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        setInputImgsOpen,
        setCategoryOpen,
        setTemplateOpen,
        setColorOpen,
    }))
    const { setDataSource, recordRef, dataSource, isBatchAppendSmartPage, setIsBatchAppendSmartPage, selectedRowKeys } = props
    const [inputImgsOpen, setInputImgsOpen] = useState(false)
    const [CategoryOpen, setCategoryOpen] = useState(false)
    const [TemplateOpen, setTemplateOpen] = useState(false)
    const [ColorOpen, setColorOpen] = useState(false)
    const [commodityCategory, setCommodityCategory] = useState({})
    const [commodityTemplate, setCommodityTemplate] = useState({})
    const [commodityColor, setCommodityColor] = useState([])
    const [colorConfig, setColorConfig] = useState('same')
    const [TemplateList, setTemplateList] = useState([])


    const list = useMemo(() => {
        return dataSource?.find(item => item.skuId === recordRef.current.skuId)?.inputImages || []
    }, [dataSource, recordRef.current.skuId])

    useMemo(() => {
        setCommodityCategory(recordRef.current?.commodityCategory || {})
        setCommodityTemplate(recordRef.current?.commodityTemplate || {})
        setCommodityColor(recordRef.current?.commodityColor || [])
    }, [recordRef.current])

    const cancleSelect = (item) => {
        setDataSource(prev =>
            prev.map(dataItem => {
                if (dataItem.skuId === recordRef.current.skuId) {
                    const updatedInputImages = dataItem.inputImages.filter(inputItem => inputItem.url !== item.url);
                    return {
                        ...dataItem,
                        inputImages: updatedInputImages
                    };
                }
                return dataItem;
            })
        );
    }

    const handleCategoryOk = () => {
        if (!commodityCategory.value) {
            return
        }
        if (isBatchAppendSmartPage && selectedRowKeys.length > 0) {
            // 批量设置
            setDataSource(prev =>
                prev.map(dataItem => {
                    if (selectedRowKeys.includes(dataItem.skuId)) {
                        return {
                            ...dataItem,
                            commodityCategory
                        };
                    }
                    return dataItem;
                })
            );
        } else {
            setDataSource(prev =>
                prev.map(dataItem => {
                    if (dataItem.skuId === recordRef.current.skuId) {
                        return {
                            ...dataItem,
                            commodityCategory
                        };
                    }
                    return dataItem;
                })
            );
        }

        setCategoryOpen(false)
        setCommodityCategory({})
        props.handleBatchExit()
    }

    const handleTemplateOk = () => {
        if (!commodityTemplate.title) return
        if (isBatchAppendSmartPage && selectedRowKeys.length > 0) {
            // 批量设置
            setDataSource(prev =>
                prev.map(dataItem => {
                    if (selectedRowKeys.includes(dataItem.skuId)) {
                        return {
                            ...dataItem,
                            commodityTemplate
                        };
                    }
                    return dataItem;
                })
            );
        } else {
            setDataSource(prev =>
                prev.map(dataItem => {
                    if (dataItem.skuId === recordRef.current.skuId) {
                        return {
                            ...dataItem,
                            commodityTemplate
                        };
                    }
                    return dataItem;
                })
            );
        }
        setTemplateOpen(false)
        setCommodityTemplate({})
        props.handleBatchExit()

    }

    const batchTemplates = () => {
        API.batchTemplates().then(res => {
            if (res.code == 0) {
                setTemplateList(res.data || [])
            }
        })
    }

    useEffect(() => {
        batchTemplates()
    }, [])


    const handleColorOk = () => {
        if (isBatchAppendSmartPage && selectedRowKeys.length > 0) {
            if (commodityColor.length === 0) return
            setDataSource(prev =>
                prev.map(dataItem => {
                    if (selectedRowKeys.includes(dataItem.skuId)) {
                        const updatedInputImages = dataItem.inputImages?.map(image => ({
                            ...image,
                            color: commodityColor?.[0].value
                        })) || [];

                        return {
                            ...dataItem,
                            commodityColor,
                            inputImages: updatedInputImages
                        };
                    }
                    return dataItem;
                })
            );
        } else {
            if (colorConfig === 'same') {
                if (commodityColor.length === 0) return
                setDataSource(prev =>
                    prev.map(dataItem => {
                        if (dataItem.skuId === recordRef.current.skuId) {
                            const updatedInputImages = dataItem.inputImages?.map(image => ({
                                ...image,
                                color: commodityColor?.[0].value
                            })) || [];

                            return {
                                ...dataItem,
                                commodityColor,
                                inputImages: updatedInputImages
                            };
                        }
                        return dataItem;
                    })
                );
            } else {
                // 遍历dataSource对应项中的inputImages中所有的color，然后去掉重复的颜色
                const currentDataItem = dataSource.find(item => item.skuId === recordRef.current.skuId);
                if (currentDataItem && currentDataItem.inputImages) {
                    const colors = currentDataItem.inputImages
                        .filter(img => img.color) // 过滤出有颜色的图片
                        .map(img => img.color); // 提取颜色值

                    // 去重
                    const uniqueColors = [...new Set(colors)];

                    const formattedColors = uniqueColors.map(color => ({
                        title: color,
                        value: color
                    }));

                    setDataSource(prev =>
                        prev.map(dataItem => {
                            if (dataItem.skuId === recordRef.current.skuId) {
                                return {
                                    ...dataItem,
                                    commodityColor: formattedColors
                                };
                            }
                            return dataItem;
                        })
                    );
                }
            }
        }

        setColorOpen(false)
        setCommodityColor([])
        setColorConfig('same')
        props.handleBatchExit()
    }


    return (
        <>
            <PSAIModal
                title='详情页图片'
                maxWidth={1020}
                okText={'确定'}
                open={inputImgsOpen}
                maskClosable={false}
                onCancel={() => setInputImgsOpen(false)}
                onOk={() => setInputImgsOpen(false)}
            >
                <div className={`${styles.SmartInputWrap} _beauty_scrollbar`}>
                    {
                        list.map((item, index) => (
                            <div key={index} className={styles.SmartInputItem}>
                                <p className={styles.DeleteIcon}
                                    onClick={() => {
                                        PSAIModal.confirm({
                                            centered: true,
                                            title: null,
                                            content: "请确认是否删除该图片？",
                                            icon: null,
                                            onOk: () => cancleSelect(item)
                                        })
                                    }
                                    }
                                ><Iconfont type="icon-DeleteOutlined" /></p>
                                <img src={Utils.getImgThumbnail(item.url)} alt="" />
                            </div>
                        ))
                    }
                </div>
            </PSAIModal>
            <PSAIModal
                title='选择类目'
                maxWidth={520}
                okText={'确定'}
                open={CategoryOpen}
                maskClosable={false}
                onCancel={() => setCategoryOpen(false)}
                onOk={() => handleCategoryOk()}
            >
                <div className={`${styles.CategoryOpenWrap}`}>
                    <Row>
                        <Col span={4} style={{ display: 'flex', alignItems: 'center', marginTop: 20 }}><span style={{ color: '#FF0000' }}>*</span>类目：</Col>
                        <Col span={18}>
                            <Select
                                value={commodityCategory?.value}
                                placeholder='请选择类目'
                                style={{ width: 360, marginTop: 30 }}
                                onChange={(value) => {
                                    const selectedOption = CategoryList.find(option => option.value === value);
                                    setCommodityCategory(selectedOption || value);
                                }}
                                options={CategoryList.map(item => ({ ...item, label: item.title }))}
                            />
                        </Col>
                    </Row>
                </div>
            </PSAIModal>
            <PSAIModal
                title='选择模板'
                maxWidth={1056}
                okText={'确定'}
                open={TemplateOpen}
                maskClosable={false}
                onCancel={() => setTemplateOpen(false)}
                onOk={() => handleTemplateOk()}
            >
                <div className={`${styles.TemplateOpenWrap} _beauty_scrollbar`}>
                    {
                        TemplateList.map((item, index) => (
                            <div key={item.id} className={styles.TemplateItem}>
                                <img className={commodityTemplate.id === item.id ? styles.Selected : ''} onClick={() => {
                                    const selectedOption = TemplateList.find(option => option.id === item.id);
                                    setCommodityTemplate(selectedOption || item);
                                }} src={Utils.getImgThumbnail(item.previewImage)} alt="" />
                                <p>{item.title?.split('-')[1] || item.title}</p>
                            </div>
                        ))
                    }
                </div>
            </PSAIModal>
            <PSAIModal
                title='选择颜色'
                maxWidth={520}
                okText={'确定'}
                open={ColorOpen}
                maskClosable={false}
                onCancel={() => setColorOpen(false)}
                onOk={() => handleColorOk()}
            >
                <div className={`${styles.ColorOpenWrap}`}>
                    {
                        !isBatchAppendSmartPage && <Row style={{ marginBottom: 24 }}>
                            <Col span={5} style={{ display: 'flex', alignItems: 'center' }}><span style={{ color: '#FF0000' }}>*</span>颜色配置：</Col>
                            <Col span={18}>
                                <Button
                                    className={styles.ColorSameBtn}
                                    type={colorConfig === 'same' ? 'primary' : 'default'}
                                    onClick={() => setColorConfig('same')}
                                >
                                    商品颜色相同
                                </Button>
                                <Button
                                    className={styles.ColorDiffBtn}
                                    type={colorConfig === 'different' ? 'primary' : 'default'}
                                    onClick={() => setColorConfig('different')}
                                >
                                    商品颜色不同
                                </Button>
                            </Col>
                        </Row>
                    }
                    {
                        colorConfig == 'same' ? <Row>
                            <Col span={5} style={{ display: 'flex', alignItems: 'center' }}><span style={{ color: '#FF0000' }}>*</span>颜色：</Col>
                            <Col span={18}>
                                <Select
                                    placeholder='请选择颜色'
                                    style={{ width: 360 }}
                                    onChange={(value) => {
                                        const selectedOption = ColorList.find(option => option.value === value);
                                        setCommodityColor([selectedOption || value]);
                                    }}
                                    options={ColorList.map(item => ({ ...item, label: item.title }))}
                                />
                                <p style={{ marginTop: 6 }}>上传的服装颜色选择越完善，生成效果越好</p>
                            </Col>
                        </Row> : list.map((item, index) => (
                            <Row key={item.id} style={{ marginBottom: 8 }}>
                                <Col span={5} style={{ display: 'flex', alignItems: 'center' }}>
                                    <img className={styles.ColorImg} src={Utils.getImgThumbnail(item.url)} alt="" />
                                </Col>
                                <Col span={18} style={{ display: 'flex', alignItems: 'center' }}>
                                    <Select
                                        placeholder='请选择颜色'
                                        style={{ width: 360 }}
                                        value={item.color}
                                        onChange={(value) => {
                                            const selectedOption = ColorList.find(option => option.value === value);
                                            // 直接修改dataSource中对应项的inputImages中对应项的color属性
                                            setDataSource(prev =>
                                                prev.map(dataItem => {
                                                    if (dataItem.skuId === recordRef.current.skuId) {
                                                        const updatedInputImages = dataItem.inputImages?.map(img => {
                                                            if (img.url === item.url) {
                                                                return {
                                                                    ...img,
                                                                    color: selectedOption?.value || value
                                                                };
                                                            }
                                                            return img;
                                                        }) || [];

                                                        return {
                                                            ...dataItem,
                                                            inputImages: updatedInputImages
                                                        };
                                                    }
                                                    return dataItem;
                                                })
                                            );
                                        }}
                                        options={ColorList.map(item => ({ ...item, label: item.title }))}
                                    />
                                </Col>
                            </Row>
                        ))
                    }

                </div>
            </PSAIModal>
        </>
    )
})

export default SmartDetailPageCom